// extracted by mini-css-extract-plugin
export default {"insight":"styles_insight__WriCD"};